export enum ForYouOpenType {
    BANNER = 1,
    WIDGET = 2,
    TILE = 3
}
export enum ForYouOpenType {
    BANNER = 1,
    WIDGET = 2,
    TILE = 3
}
